import { Button, Form, Input } from 'antd';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Card, { CardButtonWrap } from 'components/Card';
import FormItem from 'components/FormItem';
import ScrollTop from 'components/ScrollTop';
import withTransferForm, { PageIdEnum, TransferFormProps } from 'modules/Transfer/withTransferForm';
import { formatMoney } from 'utils/format';
import { getValidFloatNumberInput, isEmptyValue } from 'utils/helper';
import { PARTIAL_ACATS_BASE_PATH } from '../../helper';
import { PartialDetailsPageFormutil } from '../../type';
import style from '../style.scss';

const FillCash: FC<TransferFormProps<{ temporaryAmount: string }>> = ({
    $formutil,
    getStorageDataByKey,
    onSubmit,
    setStorageDataByKey,
    goNextPath
}) => {
    const location = useLocation();
    const locationState = location.state as { isEdit: boolean } | null;
    const isEdit = locationState?.isEdit;
    // 点进添加现金页面的时候, partialDetails页面可能还没有缓存的值
    const partialDetailsData = getStorageDataByKey<PartialDetailsPageFormutil | undefined>(PageIdEnum.PARTIAL_DETAILS);
    const { temporaryCash } = partialDetailsData || {};
    const {
        $params: { temporaryAmount },
        $setValues
    } = $formutil;

    useEffect(() => {
        if (!isEmptyValue(temporaryCash)) {
            // isEmptyValue会判断, 所以这里temporaryCash一定有值, 可以非空断言
            $setValues({ temporaryAmount: formatMoney(temporaryCash!).replace(/,/g, '') });
        }
    }, [temporaryCash, $setValues]);

    const handleSubmit = () => {
        onSubmit(() => {
            // 需要更新partial-details的temporaryCash
            setStorageDataByKey(PageIdEnum.PARTIAL_DETAILS, {
                ...partialDetailsData,
                temporaryCash: parseFloat(temporaryAmount)
            });

            goNextPath('../partial-details');
        });
    };
    const handleDelete = () => {
        onSubmit(() => {
            // 需要更新partial-details的temporaryCash
            setStorageDataByKey(PageIdEnum.PARTIAL_DETAILS, {
                ...partialDetailsData,
                // 删除的时候把上级表单的temporaryCash置空
                temporaryCash: ''
            });

            goNextPath('../partial-details');
        });
    };

    return (
        <Card form>
            <ScrollTop />
            <h3 className="transfer-title">{__('Transfer Cash Details')}</h3>
            <Form noValidate layout="vertical" onFinish={handleSubmit}>
                <FormItem
                    label={__('Cash amount in USD')}
                    name="temporaryAmount"
                    className={style.numberInputItem}
                    $parser={($viewValue, $setViewValue) => $setViewValue(getValidFloatNumberInput($viewValue, true))}
                    checker={value => {
                        if (isEmptyValue(value)) {
                            return __('Please enter cash amount');
                        }

                        // 判断小数部分是否超过2位
                        const splitNumber = value.split('.');

                        if (splitNumber.length > 1 && splitNumber[1].length > 2) {
                            return __('Only numbers can be entered, with a maximum of two decimal places.');
                        }

                        return true;
                    }}>
                    <Input placeholder={__('Enter')} autoComplete="off" />
                </FormItem>
                <CardButtonWrap className="mt-5">
                    <Button size="large" onClick={isEdit ? handleDelete : () => goNextPath('../partial-details')}>
                        {isEdit ? __('Delete') : __('Back')}
                    </Button>
                    <Button type="primary" size="large" htmlType="submit">
                        {isEdit ? __('Save') : __('Add List')}
                    </Button>
                </CardButtonWrap>
            </Form>
        </Card>
    );
};

export default withTransferForm({
    id: PageIdEnum.FILL_CASH,
    step: 3,
    basePath: PARTIAL_ACATS_BASE_PATH,
    // 这个页面的内容只是为了操作表单, 甚至可以理解为一个弹窗, 不需要缓存表单值
    cache: false,
    /**
     * 使用PageIdEnum.BROKER/PageIdEnum.CHECK来判断是否是手敲链接的误入
     * 注意这里不能加PageIdEnum.PARTIAL_DETAILS
     * 因为首次进入的时候缓存中还没有PageIdEnum.PARTIAL_DETAILS的值
     */
    ensure: [PageIdEnum.BROKER, PageIdEnum.CHECK]
})(FillCash);
